import { createEnrichmentIsland } from "@/utils/islands";
import { fetchApi } from "@/utils/fetcher";
import { clearSession, getRefreshToken } from "../Store/tokenstore";

async function logout() {
  const refreshToken = getRefreshToken();
  if (refreshToken) {
    try {
      await fetchApi('/authentication/logout', {
        method: 'POST',
        body: JSON.stringify({ refreshToken }),
      });
    } catch (err) {
      console.error('Logout fejlede', err);
    }
  }

  clearSession();
  document.location.href = '/';
}

const clickHandler = (e: MouseEvent) => {
  e.preventDefault();
  logout();
}

export default function init() {
  createEnrichmentIsland('[logout-btn]', (elm: Element) => {
    elm.addEventListener('click', (event: Event) => clickHandler(event as MouseEvent));
  });
}
